<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="create()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Nova entrada de estoque"
    >
        <b-tabs vertical pills >
            <b-tab title="Informações básicas" active class="border p-4" >
                <div class="form-row">
                    <div class="col-md-4">
                        <b-form-group
                            label="Unidade"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Tipo de unidade"
                                v-model="form.unidade"
                                size="sm"
                            />
                            <small v-if="!$v.form.unidade.required" >Campo requerido</small>
                            <small v-if="!$v.form.unidade.maxLength" >Não corresponde a uma medida.</small>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group
                            label="Estante"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Nº Estante"
                                v-model="form.estante"
                                size="sm"
                            />
                            <small v-if="!$v.form.estante.maxLength" >Campo inválido</small>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group
                            label="Prateleira"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Nº Prateleira"
                                v-model="form.prateleira"
                                size="sm"
                            />

                            <small v-if="!$v.form.prateleira.maxLength" >Campo requerido</small>
                        </b-form-group>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-6 col-12">
                        <b-form-group
                            label="Descrição (Nome do produto)"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Descrição do produto"
                                v-model="form.descricao"
                                size="sm"
                            />
                            <small v-if="!$v.form.descricao.required" >É necessário uma descrição.</small>
                            <small v-if="!$v.form.descricao.minLength" >A descrição precisa ser maior que 12 caracteres</small>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-group
                            label="Setor"
                        >

                            <v-select 
                                :options="setores" 
                                v-model="form.setor"
                                :searchable="true" 
                                textProp="descricao"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-6">
                        <b-form-group
                            label="Grupo"
                        >
                            <v-select 
                                :options="grupos" 
                                v-model="form.grupo"
                                :searchable="true" 
                                textProp="descricao"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Sub-Grupo"
                        >
                            <v-select 
                                :options="subGrupos" 
                                v-model="form.subgrupo"
                                :searchable="true" 
                                textProp="descricao"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-6">

                        <b-form-group
                            label="Marca"
                        >
                            <v-select 
                                :options="marcas" 
                                v-model="form.marca"
                                :searchable="true" 
                                textProp="descricao"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Fornecedor"
                        >
                            <v-select 
                                :options="fornecedores" 
                                v-model="form.fornecedor"
                                :searchable="true" 
                                textProp="DESCRICAO"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12">
                        <b-form-group
                            label="Descrição complementar"
                        >
                            <b-form-textarea
                                v-model="form.complementodescricao"
                                placeholder="Descrição complementar ..."
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>

                            <small v-if="!$v.form.complementodescricao.minLength && $v.form.complementodescricao.dirty" >A descrição complementar esta muito curta</small>
                            <small v-if="!$v.form.complementodescricao.maxLength && $v.form.complementodescricao.dirty" >A descrição complementar esta muito longa</small>
                        </b-form-group>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-6">
                        <b-form-group
                            label="Código de barras"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Código de barras"
                                v-model="form.barras"
                                size="sm"
                            />

                            <small v-if="!$v.form.barras.minLength && $v.form.barras.dirty" >O código de barras esta muito curto</small>
                            <small v-if="!$v.form.barras.maxLength && $v.form.barras.dirty" >O código de barras esta muito longo</small>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Referencia"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Referencia"
                                v-model="form.referencia"
                                size="sm"
                            />
                        </b-form-group>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Valores e custos" class="border p-4" >
                <div class="form-row">
                    <div class="col-md-6">
                        <input-moeda
                            v-model="form.valorcompra"
                            texto="Valor da compra"
                            titulo="Valor da Compra"
                        />
                    </div>
                    <div class="col-md-6">
                        <input-moeda
                            v-model="form.custofinal"
                            texto="Custo final"
                            titulo="Custo final"
                        />
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <input-moeda
                            v-model="form.precovarejo"
                            texto="Preço varejo"
                            titulo="Preço varejo"
                        />
                    </div>
                    <div class="col-md-6">
                        <input-moeda
                            v-model="form.precoatacado"
                            texto="Preço atacado"
                            titulo="Preço atacado"
                        />
                    </div>
                </div>
            </b-tab>
            <b-tab title="Gestor Food" class="border p-4" >
                <div class="form-row">
                    <div class="col-md-6">
                        <b-form-group
                            label="Código manual"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Código manual"
                                v-model="form.codigomanual"
                                size="sm"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Favorito"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Favorito"
                                v-model="form.favorito"
                                size="sm"
                            />
                        </b-form-group>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <b-form-group
                            label="Setor de impressão"
                        >

                            <v-select 
                                :options="setores" 
                                v-model="form.setorimpressao"
                                :searchable="true" 
                                textProp="descricao"
                                valueProp="id"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Tempo de preparo"
                        >
                            <b-form-input
                                type="text"
                                placeholder="Tempo de preparo"
                                v-model="form.tempopreparo"
                                size="sm"
                            />
                        </b-form-group>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </jt-form>
</template>
<script>
import jtForm from '@/components/form.vue'
import inputMoeda from '@/components/inputMoeda.vue'
import VSelect from '@alfsnd/vue-bootstrap-select'
import { 
    required, 
    numeric, 
    minValue,
    maxValue,
    minLength,
    maxLength
} from 'vuelidate/lib/validators'

export default {
    name: 'vwEditarProduto',

    data(){
        return {
            alert: {
                type: 'alert-warning',
                message: '',
                show: false
            },

            form: {
                unidade: null,
                estante: null,
                prateleira: null,
                descricao: null,
                setor: null,
                grupo: null,
                subgrupo: null,
                fornecedor: null,
                marca: null,
                complementodescricao: null,
                barras: null,
                referencia: null,
                valorcompra: null,
                custofinal: null,
                precovarejo: null,
                precoatacado: null,
                codigomanual: null,
                favorito: null,
                setorimpressao: null,
                tempopreparo: null,
                quantidade: null
            },

            setores: [],
            fornecedores: [],
            grupos: [],
            subGrupos: [],
            marcas: [],
            setoresImp: [],
        }
    },

    validations: {
        form: {
            unidade: {
                required,
                maxLength: maxLength(4)
            },
            estante: {
                maxLength: maxLength(4)
            },
            prateleira: {
                maxLength: maxLength(4)
            },
            descricao: {
                required,
                minLength: minLength(12)
            },

            complementodescricao: {
                minValue: minLength(32),
                maxValue: maxLength(512)
            },

            barras: {
                numeric,
                minValue: minValue(14),
                maxValue: maxValue(14)
            },

            codigomanual: {
                numeric,
                minValue: minValue(0)
            }
        }
    },

    components: {
        jtForm,
        VSelect,
        inputMoeda
    },

    computed: {
        getToken(){
            return this.$store.getters.getToken
        },

        id(){
            return this.$route.params.id
        }
    },

    methods: {
        getData: function(){
            fetch(server + 'crud/produtos/' + this.id, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token' : this.getToken
                })
            })
                .then(res => (res.json()))
                .then(response => {
                    if(response.data){
                        this.form = {
                            descricao: response.response[0].descricao,
                            unidade: response.response[0].unidade,
                            grupo: response.response[0].grupo,
                            fornecedor: response.response[0].fornecedor,
                            barras: response.response[0].barra,
                            setor: response.response[0].setor,
                            subgrupo: response.response[0].sub_grupo,
                            marca: response.response[0].marca,
                            estante: response.response[0].estante,
                            prateleira: response.response[0].prateleira,
                            custofinal: response.response[0].custo,
                            precovarejo: response.response[0].preco_venda,
                            quantidade: response.response[0].estoque,
                            valorcompra: response.response[0].precocompra,
                            complementodescricao: response.response[0].complementodescricao,
                            precoatacado: response.response[0].preco_atacado
                        }
                    }else{
                        this.alert = {
                            type: 'warning',
                            message: response.message,
                            show: true
                        }
                    }
                })
                .catch(error => {
                    this.alert = {
                        type: 'danger',
                        message: 'Erro ao buscar dados',
                        show: true
                    }
                })
        },

        clear: function(){
           for(let prop in this.form){
               this.form[prop] = null
           }
        },
        create: function(){
            let formErrors  = this.$v.form.$invalid

            if(formErrors === false){
                let formBody = []

                for (let prop in this.form) {
                    if(this.form[prop] !== null){
                        let encodedKey = encodeURIComponent(prop)

                        if(
                            [
                                'setor', 
                                'grupo',
                                'subgrupo',
                                'fornecedor',
                                'marca',
                                'setorimpressao'
                            ].includes(prop)
                        ){
                            var encodedValue = encodeURIComponent(this.form[prop].id)
                        }else{
                            var encodedValue = encodeURIComponent(this.form[prop])
                        }


                        formBody.push(encodedKey + "=" + encodedValue)
                    }
                }

                formBody = formBody.join("&")

                fetch(server + 'crud/estoque/' + this.id, {
                    method: 'PUT',
                    headers: new Headers({
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'token' : this.getToken
                    }),
                    body: formBody
                })
                    .then(res => (res.json()))
                    .then(response => {
                        if(response.data){
                            this.alert = {
                                type: 'success',
                                message: 'Produto cadastrado',
                                show: true
                            }
                        }else{
                            this.alert = {
                                type: 'warning',
                                message: response.message,
                                show: true
                            }
                        }
                    })
                    .catch(error => {
                        this.alert = {
                            type: 'danger',
                            message: 'Erro ao cadastrar',
                            show: true
                        }
                    })
            }else{
                this.alert = {
                    type: 'warning',
                    message: 'Existem campos inválidos',
                    show: true
                }
            }
            
        },

        closeAlert: function(){
            this.alert = {
                type: 'alert-warning',
                message: '',
                show: false
            }
        },

        buscarFornecedores: function(){
            fetch(server + 'crud/duplicatas/fornecedores', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.fornecedores = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarSetores: function(){
            fetch(server + 'crud/setores', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.fornecedores = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarGrupos: function(){
            fetch(server + 'crud/grupo', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.grupos = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarSubGrupos: function(){
            fetch(server + 'crud/sub-grupos', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.subGrupos = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarMarcas: function(){
            fetch(server + 'crud/marcas', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.marcas = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        },

        buscarSetorImpressao: function(){
            fetch(server + 'crud/setores-impressao', {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => {
                    if(response.status == 200){
                        response.json()
                            .then(data => {
                                if(data.data){
                                    this.setoresImp = data.response
                                }else{
                                    console.error('Error exception', '=>', data.message)
                                }
                            })
                            .catch(error => {
                                console.error('Error exception', '=>', error.message)
                            })
                    }else{
                        console.error('Error exception', '=>', response.statusText)
                    }
                })
                .catch(error => {
                    console.error('Error exception', '=>', error.message)
                })
        }
    },

    mounted(){
        this.buscarFornecedores()
        this.buscarSetores()
        this.buscarGrupos()
        this.buscarSubGrupos()
        this.buscarMarcas()
        this.buscarSetorImpressao()

        this.getData()
    }
}
</script>